import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const customColors = {
	"light-grey": "#f1f1f1",
	"pale-grey": "#f0f0f8",
	ocean: "#00838b",
	orange: "#d19b07",
	"warm-blue": "#4c43db",
	"rust-red": "#cc4c3b",
};

export default new Vuetify({
	icons: {
		iconfont: "fa",
	},
	theme: {
		options: {
			/**
			 * Enabling this option generates CSS variables for each theme color:
			 * <style scoped>
			 *   .something { color: var(--v-primary-base); }
			 * </style>
			 *
			 * This even works for our custom colors defined below, with
			 * variations:
			 * --v-ocean-base
			 * --v-ocean-lighten[1-5]
			 * --v-ocean-darken[1-4]
			 *
			 * It can also be used wherever a `color` attribute is suppported
			 * in Vuetify components:
			 * <v-icon color="ocean lighten-2">fa-pencil</v-icon>
			 */
			customProperties: true,
		},
		themes: {
			// Some additions of our own...
			// NOTE: Colors are only available in the theme in which they are
			//       defined.
			light: customColors,
			dark: customColors,
		},
	},
});
